<template>
  <span class="mention-text">
    <template v-for="(part, index) in parts" :key="index">
      <span v-if="part.type === 'mention'" class="mention-chip">{{ part.text }}</span>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script>
import { splitMentionParts } from "@/utils/mentionUsers";

export default {
  name: "MentionText",
  props: {
    text: { type: [String, Number], default: "" },
  },
  computed: {
    parts() {
      return splitMentionParts(this.text);
    },
  },
};
</script>
